// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { IMessageSender } from "@lib/messaging/IMessageSender";

/**
 * Provides an API for creating an `IMessagesSender` which can send messages for certain message format.
 */
export interface IMessageSenderFactory
{
  createMessageSender(format: string): IMessageSender;
}